export enum Authorities {
  AD_CREATE = "AD-CREATE",
  AD_DELETE = "AD-DELETE",
  AD_GETALL = "AD-GETALL",
  AD_GETLIST = "AD-GETLIST",
  AD_READ = "AD-READ",
  AD_UPDATE = "AD-UPDATE",

  ADC_ADD_JUSTIFICATION_FILE = "ADC-ADD-JUSTIFICATION-FILE",
  ADC_ADD_SYNTHESIS_REPORT = "ADC-ADD-SYNTHESIS-REPORT",
  ADC_CALENDAR = "ADC-CALENDAR",
  ADC_CREATE = "ADC-CREATE",
  ADC_DELETE = "ADC-DELETE",
  ADC_GETALL = "ADC-GETALL",
  ADC_READ = "ADC-READ",
  ADC_UPDATE = "ADC-UPDATE",

  ADMIN_CREATE = "ADMIN-CREATE",
  ADMIN_DELETE = "ADMIN-DELETE",
  ADMIN_GETALL = "ADMIN-GETALL",
  ADMIN_MAIN = "ADMIN-MAIN",
  ADMIN_SIDEBAR = "ADMIN-SIDEBAR",
  ADMIN_UPDATE = "ADMIN-UPDATE",

  B_UPDATE = "B-UPDATE",

  BR_GETALL = "BR-GETALL",
  BR_UPDATE = "BR-UPDATE",

  C_GETALL = "C-GETALL",

  CT_CREATE = "CT-CREATE",
  CT_DELETE = "CT-DELETE",
  CT_GETALL = "CT-GETALL",
  CT_UPDATE = "CT-UPDATE",

  FC_CREATE = "FC-CREATE",
  FC_DELETE = "FC-DELETE",
  FC_GETALL = "FC-GETALL",
  FC_UPDATE = "FC-UPDATE",

  GA_GETALL = "GA-GETALL",

  GC_DELETE = "GC-DELETE",
  GC_GET = "GC-GET",
  GC_GETALL = "GC-GETALL",
  GC_UPDATE = "GC-UPDATE",

  H_GETALL = "H-GETALL",

  LP_CALCULATEAVERAGE = "LP-CALCULATEAVERAGE",
  LP_CREATE = "LP-CREATE",
  LP_DELETE = "LP-DELETE",
  LP_GETALL = "LP-GETALL",
  LP_GETCOST = "LP-GETCOST",
  LP_GETDATES = "LP-GETDATES",
  LP_GETEXPENSES = "LP-GETEXPENSES",
  LP_GETPROFILE = "LP-GETPROFILE",
  LP_GRANTPREMIUM = "LP-GRANTPREMIUM",
  LP_PAYMENT_GETALL = "LP-PAYMENT-GETALL",
  LP_PAYMENT_UPDATE = "LP-PAYMENT-UPDATE",
  LP_REVIEW = "LP-REVIEW",
  LP_UPDATE = "LP-UPDATE",
  LP_UPDATEAVERAGE = "LP-UPDATEAVERAGE",

  MAIL_APPROVEACCOUNT = "MAIL-APPROVEACCOUNT",
  MAIL_APPROVEAD = "MAIL-APPROVEAD",
  MAIL_CREATELP = "MAIL-CREATELP",
  MAIL_MARKADFINISHED = "MAIL-MARKADFINISHED",
  MAIL_RESETPASSWORD = "MAIL-RESETPASSWORD",
  MAIL_UPDATEAD = "MAIL-UPDATEAD",

  OJ_UPDATE = "OJ-UPDATE",

  PROMOTION_CREATE = "P-CREATE",
  PROMOTION_DELETE = "P-DELETE",
  PROMOTION_GETALL = "P-GETALL",
  PROMOTION_UPDATE = "P-UPDATE",

  REGION_CREATE = "REGION-CREATE",
  REGION_DELETE = "REGION-DELETE",
  REGION_GETALL = "REGION-GETALL",
  REGION_UPDATE = "REGION-UPDATE",

  ROLE_GETALL = "ROLE-GETALL",
  ROLE_ADMIN = "ROLE_ADMIN",

  ROUTER_CREATE = "ROUTER-CREATE",
  ROUTER_DELETE = "ROUTER-DELETE",
  ROUTER_GETALL = "ROUTER-GETALL",
  ROUTER_UPDATE = "ROUTER-UPDATE",

  SCT_CREATE = "SCT-CREATE",
  SCT_DELETE = "SCT-DELETE",
  SCT_GETALL = "SCT-GETALL",
  SCT_UPDATE = "SCT-UPDATE",

  SROLE_CREATE = "SROLE-CREATE",
  SROLE_DELETE = "SROLE-DELETE",
  SROLE_GET = "SROLE-GET",
  SROLE_UPDATE = "SROLE-UPDATE",

  STAT_GETALLSTATS = "STAT-GETALLSTATS",

  TAG_CREATE = "TAG-CREATE",
  TAG_DELETE = "TAG-DELETE",
  TAG_UPDATE = "TAG-UPDATE",

  USER_HISTORY = "USER-HISTORY",

  ZONE_CREATE = "ZONE-CREATE",
  ZONE_DELETE = "ZONE-DELETE",
  ZONE_GETALL = "ZONE-GETALL",
  ZONE_UPDATE = "ZONE-UPDATE",
  LP_IMPRESSIONS = "LP-IMPRESSIONS",
  LP_PRICES = "LP-PRICES",
  OJ_GETALL = "OJ-GETALL",

  P_GETALL = "P-GETALL",

  TAG_GETALL = "TAG-GETALL",

  VOUCHER_GETALL = "VOUCHER-GETALL",

  FR_MAIN = "FR-MAIN",
  FR_TOP_FRANCHISED = "FR-TOP-FRANCHISED",

  FR_ASSOCIATED_LOCATIONS_LIST = "FR-ASSOCIATED-LOCATIONS-LIST"
}
